export default __webpack_public_path__ + "static/5-c043bb906748b0705490c28aa0c98025.jpeg";